import { COMMON_ENTITIES } from 'src/utils/entityDefinitions/entities/commonEntities';

export const OMNI_ENTITIES = {
  ...COMMON_ENTITIES
};
